import { render } from "./ArrowRight.vue?vue&type=template&id=ad71403a"
import script from "./ArrowRight.vue?vue&type=script&lang=js"
export * from "./ArrowRight.vue?vue&type=script&lang=js"
script.render = render

export default script